export default __webpack_public_path__ + "static/media/ani-scale-3x.5fbd8a62.png";